import React from 'react';
import { ColumnsV2 } from '@withjoy/joykit';

const CoverPhotoWrapper = ({
  children,
  renderFullColumn = true,
  isCustomPage,
  isNativeAccommodations,
  subTitle,
}: {
  children: React.ReactNode;
  renderFullColumn?: boolean;
  isCustomPage: boolean;
  isNativeAccommodations: boolean;
  subTitle?: string | null;
}) => {
  return (
    <ColumnsV2.Column
      style={isCustomPage ? { display: isNativeAccommodations && !subTitle ? 'none' : 'block' } : {}}
      span={renderFullColumn ? 12 : [12, 10]}
      offset={renderFullColumn ? 0 : [0, 1]}
    >
      {children}
    </ColumnsV2.Column>
  );
};

CoverPhotoWrapper.displayName = 'CoverPhotoWrapper';

export { CoverPhotoWrapper };
